import { useTranslation } from "react-i18next";

export interface SelectOption {
  value: string;
  label: string;
}

export interface UseAuditContextOptionsReturn {
  mediumTypeOptions: SelectOption[];
  targetAudienceOptions: SelectOption[];
  communicationPurposeOptions: SelectOption[];
}

/**
 * Hook to get audit context form options with translated labels
 * Uses upload:context.mediumType.options.*, upload:context.targetAudience.options.*
 * and upload:context.communicationPurpose.options.* namespaces
 */
export function useAuditContextOptions(): UseAuditContextOptionsReturn {
  const { t } = useTranslation(["upload"]);

  const mediumTypeOptions: SelectOption[] = [
    { value: "", label: t("upload:context.mediumType.placeholder") },
    { value: "website", label: t("upload:context.mediumType.options.website") },
    { value: "social_media", label: t("upload:context.mediumType.options.social_media") },
    { value: "advertising", label: t("upload:context.mediumType.options.advertising") },
    { value: "packaging", label: t("upload:context.mediumType.options.packaging") },
    { value: "press_release", label: t("upload:context.mediumType.options.press_release") },
    { value: "corporate_report", label: t("upload:context.mediumType.options.corporate_report") },
    { value: "product_label", label: t("upload:context.mediumType.options.product_label") },
    { value: "email_marketing", label: t("upload:context.mediumType.options.email_marketing") },
    { value: "other", label: t("upload:context.mediumType.options.other") },
  ];

  const targetAudienceOptions: SelectOption[] = [
    { value: "", label: t("upload:context.targetAudience.placeholder") },
    { value: "general_consumers", label: t("upload:context.targetAudience.options.general_consumers") },
    { value: "existing_customers", label: t("upload:context.targetAudience.options.existing_customers") },
    { value: "business_customers", label: t("upload:context.targetAudience.options.business_customers") },
    { value: "internal_employees", label: t("upload:context.targetAudience.options.internal_employees") },
  ];

  const communicationPurposeOptions: SelectOption[] = [
    { value: "", label: t("upload:context.communicationPurpose.placeholder") },
    { value: "commercial", label: t("upload:context.communicationPurpose.options.commercial") },
    { value: "educational_csr", label: t("upload:context.communicationPurpose.options.educational_csr") },
  ];

  return { mediumTypeOptions, targetAudienceOptions, communicationPurposeOptions };
}
